export default __webpack_public_path__ + "static/media/mynotes.a5909133.ico";